import { endPoints, requestType } from "../constants/Variables";
import Api from "./index";

const getAllOrders = (query) => {
  const url = endPoints.allOrders;

  const queryParams = new URLSearchParams();
  if (query.orderId) queryParams.append("orderId", query.orderId);
  if (query.page) queryParams.append("page", query.page);
  if (query.limit) queryParams.append("limit", query.limit);

  const finalUrl = queryParams.toString()
    ? `${url}?${queryParams.toString()}`
    : url;
  return Api(finalUrl, null, requestType.GET);
};

const getAllSupplierOrders = (id, query) => {
  const url = endPoints.getAllSupplierOrders.replace(":supplierId", id);

  const queryParams = new URLSearchParams();
  if (query.orderId) queryParams.append("orderId", query.orderId);
  if (query.page) queryParams.append("page", query.page);
  if (query.limit) queryParams.append("limit", query.limit);

  const finalUrl = queryParams.toString()
    ? `${url}?${queryParams.toString()}`
    : url;
  return Api(finalUrl, null, requestType.GET);
};

const getOrderDetailById = (id) => {
  return Api(
    endPoints.getOrderDetailById.replace(":id", id),
    null,
    requestType.GET,
  );
};

const getSupplierOrderDetail = (supplierId, id) => {
  return Api(
    endPoints.getSupplierOrderDetail
      .replace(":id", id)
      .replace(":supplierId", supplierId),
    null,
    requestType.GET,
  );
};

const updateSupplierOrderItemStatus = (id, itemId, status) => {
  return Api(
    endPoints.updateSupplierOrderItemStatus
      .replace(":id", id)
      .replace(":itemId", itemId),
    status,
    requestType.PATCH,
  );
};

const updateSupplierOrderStatusInBulk = (id, payload) => {
  return Api(
    endPoints.updateSupplierOrderStatusesInBulk.replace(":id", id),
    payload,
    requestType.PATCH,
  );
};

const supplierGetAllCLients = (id, query) => {
  return Api(
    `${endPoints.supplierGetAllCLients}/${id}?search=${query.search}`,
    null,
    requestType.GET,
  );
};

const supplierGetOrderDetail = (id) => {
  return Api(
    `${endPoints.supplierGetOrderDetail}/${id}`,
    null,
    requestType.GET,
  );
};

const supplierUpdateOrderStatus = (id, params) => {
  return Api(
    `${endPoints.supplierUpdateOrderStatus}/${id}`,
    params,
    requestType.PUT,
  );
};

const supplierHandleProductRefund = (orderId, orderItemId, productId) => {
  return Api(
    `${endPoints.supplierHandleProductRefund}/${orderId}/${orderItemId}/${productId}`,
    null,
    requestType.PUT,
  );
};

const supplierOrderCancelAndRefund = (orderId, orderItemId) => {
  return Api(
    `${endPoints.supplierOrderCancelAndRefund}/${orderId}/${orderItemId}`,
    null,
    requestType.PUT,
  );
};

const supplierReplaceProduct = (
  orderId,
  orderItemId,
  productId,
  newProduct,
) => {
  return Api(
    `${endPoints.supplierReplaceProduct}/${orderId}/${orderItemId}/${productId}`,
    newProduct,
    requestType.PUT,
  );
};

const exportAllOrders = () => {
  return Api(endPoints.exportAllOrders, null, requestType.GET);
};

const exportSupplierOrders = (supplierId) => {
  return Api(
    endPoints.exportSupplierOrders.replace(":supplierId", supplierId),
    null,
    requestType.GET,
  );
};

export {
  getAllOrders,
  getAllSupplierOrders,
  getOrderDetailById,
  getSupplierOrderDetail,
  updateSupplierOrderItemStatus,
  supplierGetAllCLients,
  supplierGetOrderDetail,
  supplierUpdateOrderStatus,
  supplierHandleProductRefund,
  supplierOrderCancelAndRefund,
  supplierReplaceProduct,
  exportSupplierOrders,
  exportAllOrders,
  updateSupplierOrderStatusInBulk,
};
